//
//
//
//

export default {
  name: "MatrixTextbox",
	props: ["value"],
	methods: {
    input(e) {
      this.$emit("input", e.target.value);
    }
	}
};
